import { render, staticRenderFns } from "./common_header.vue?vue&type=template&id=6b3b8afe&scoped=true&lang=pug"
import script from "./common_header.vue?vue&type=script&setup=true&lang=js"
export * from "./common_header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./common_header.vue?vue&type=style&index=0&id=6b3b8afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8afe",
  null
  
)

export default component.exports